/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2020-05-11 15:51:28
 */

import React from 'react';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import qs from 'query-string' 
// @ts-ignore
import s from './Ranktable.css';
// @ts-ignore
import icon_db from './icon-db.png';
// @ts-ignore
import icon_count from './icon-count.png';
// @ts-ignore
import icon_increase from './icon-increase.png';
// @ts-ignore
import icon_mind from './icon-mind.png';
import cx from 'classnames';
// import GetTbody from '../GetTbody'
import Link from '../Link'
import Calendar from '../Calendar'
import moment from 'moment'
// @ts-ignore
import loadGif from './loading.gif'
// @ts-ignore
import errPic from './errPic.gif'

import Txt from './rankingList'
import { 
  getBrandAndDataLength,
  getChampionJsonDay,
  getChampionJsonDayCard,
  getChampionJsonWeek,
  getChampionJsonWeekCard,
  getChampionJsonMonth,
  getChampionJsonMonthCard,
  getIndustryJsonDay,
  getIndustryJsonDayCard,
  getIndustryJsonWeek,
  getIndustryJsonWeekCard,
  getIndustryJsonMonth,
  getIndustryJsonMonthCard,
  getPlatformJsonDay,
  getPlatformJsonDayCard,
  getPlatformJsonWeek,
  getPlatformJsonWeekCard,
  getPlatformJsonMonth,
  getPlatformJsonMonthCard,
  getGeoJsonDayCard,
  getGeoJsonDay,
  getGeoJsonWeek,
  getGeoJsonWeekCard,
  getGeoJsonMonth,
  getGeoJsonMonthCard
} from '../../controller';


const btn = ['日榜', '周榜', '月榜']

const brandIcon = id => `/digitalAssets/resources/img/LOGO/${id}.png`
const aLink = query => `/dashboard?${qs.stringify(query)}`

class Ranktable extends React.Component {
  static defaultProps = {
    tit: '',
    rank: 'ranking'
  }
  static propTypes = {
    // items:PropTypes.Array.isRequired
  };

  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      getTime: '',
      periodIndex: 0,
      rankItems:[],
      cardItems: [{
        name: '腾讯',
        value: 1234
      }, {
        name: '腾讯',
        isUp: 'up',
        value: '+45.00%'
      }, {
        name: '腾讯',
        isUp: 'down',
        value: '-60.00%'
      }, {
        name: '腾讯',
        value: '98.00%'
      }],
      selectTime: null,
      isShow: false,
      error:false,
      isCalendarCon:false,
      brandCount:'',
      dataLength:'',
      lookMoreRank:false,
      isShowLabel:false,
    }

    this.isInit=false
  }

  enCalendarCon=()=>{
    this.setState({
      isCalendarCon:true
    })
  }

  ovCalendarCon=()=>{
    this.setState({
      isCalendarCon:false
    })
  }

  // 加载中
  loadingShow=()=>{
    return (
      <div className={s.loadingBox}>
        <img src={loadGif}/>
      </div>
    )
  }


  getSelectTime(time) {
    // console.log(time)
    // this.setState({selectTime:time})
  }


  changeSelecPeriod = ({index=this.state.periodIndex, nextTime = undefined, lookMoreRank=this.state.lookMoreRank}, {tit=this.props.tit}) => {
    //改变函数接受参数 (this.state,this.props)
    this.setState({
      periodIndex: index,
      lookMoreRank,
    })

    const {selectTime}=this.state

    const defaultWeek = moment().format('d') == '1' && moment().format('a') == 'am'
      ? `${moment().day(-13).format('YYYY-MM-DD')} 至 ${moment().day(-7).format('YYYY-MM-DD')}`
      : `${moment().day(-6).format('YYYY-MM-DD')} 至 ${moment().day(0).format('YYYY-MM-DD')}`

    const defaultMonth = moment().format('D') == '1' && moment().format('a')=='am'
      ? moment().subtract(2,'month').format('YYYY-MM')
      : moment().subtract(1,'month').format('YYYY-MM')

    let ss,artTime

    switch (this.props.rank + index) {
      case ('ranking' + 0):
        ss = nextTime||moment().subtract(1,'days').format('YYYY-MM-DD')
        this.setState({
          selectTime:ss
        })
        if(nextTime){
          artTime=(`${moment(nextTime,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(nextTime,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        }else{
          artTime=(`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`)
        }
        this.props.getArtTime(artTime)

        // this.getChampionJsonDay(ss)
        this.doFetchData('getChampionJsonDay',ss,tit,lookMoreRank)
        break
      case ('ranking' + 1):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM-DD').day(7).format('YYYY-MM-DD')
        }else{
          ss=moment().day(0).format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultWeek})
        this.props.getArtTime(artTime)
        // this.getChampionJsonWeek(ss)
        
        this.doFetchData('getChampionJsonWeek',ss,tit,lookMoreRank)
        break
      case ('ranking' + 2):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM').add(1,'month').subtract(1,'days').format('YYYY-MM-DD')
        }else{
          ss=moment().date(1).subtract(1,'days').format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').date(1).format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultMonth})
        this.props.getArtTime(artTime)
        // this.getChampionJsonMonth(ss)
        this.doFetchData('getChampionJsonMonth',ss,tit,lookMoreRank)
        break
      case ('geo' + 0):
        ss=nextTime||moment().subtract(1,'days').format('YYYY-MM-DD')
        this.setState({selectTime:ss})
        if(nextTime){
          artTime=(`${moment(nextTime,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(nextTime,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        }else{
          artTime=(`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`)
        }
        
        this.props.getArtTime(artTime)
        this.doFetchData('getGeoJsonDay',ss,tit,lookMoreRank)
        break
      case ('geo' + 1):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM-DD').day(7).format('YYYY-MM-DD')
        }else{
          ss=moment().day(0).format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultWeek})
        this.props.getArtTime(artTime)
        this.doFetchData('getGeoJsonWeek',ss,tit,lookMoreRank)
        break
      case ('geo' + 2):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM').add(1,'month').subtract(1,'days').format('YYYY-MM-DD')
        }else{
          ss=moment().date(1).subtract(1,'days').format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').date(1).format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultMonth})
        this.props.getArtTime(artTime)
        this.doFetchData('getGeoJsonMonth',ss,tit,lookMoreRank)
        break
      case ('industry' + 0):
        ss=nextTime||moment().subtract(1,'days').format('YYYY-MM-DD')
        this.setState({selectTime:ss})
        if(nextTime){
          artTime=(`${moment(nextTime,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(nextTime,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        }else{
          artTime=(`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`)
        }
        this.props.getArtTime(artTime)
        this.doFetchData('getIndustryJsonDay',ss,tit,lookMoreRank)
        break
      case ('industry' + 1):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM-DD').day(7).format('YYYY-MM-DD')
        }else{
          ss=moment().day(0).format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultWeek})
        this.props.getArtTime(artTime)
        this.doFetchData('getIndustryJsonWeek',ss,tit,lookMoreRank)
        break
      case ('industry' + 2):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM').add(1,'month').subtract(1,'days').format('YYYY-MM-DD')
        }else{
          ss=moment().date(1).subtract(1,'days').format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').date(1).format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultMonth})
        this.props.getArtTime(artTime)
        this.doFetchData('getIndustryJsonMonth',ss,tit,lookMoreRank)
        break
      case ('platform' + 0):
        ss=nextTime||moment().subtract(1,'days').format('YYYY-MM-DD')
        this.setState({selectTime:ss})
        if(nextTime){
          artTime=(`${moment(nextTime,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(nextTime,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        }else{
          artTime=(`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`)
        }
        this.props.getArtTime(artTime)
        this.doFetchData('getPlatformJsonDay',ss,tit,lookMoreRank)
        break
      case ('platform' + 1):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM-DD').day(7).format('YYYY-MM-DD')
        }else{
          ss=moment().day(0).format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultWeek})
        this.props.getArtTime(artTime)
        this.doFetchData('getPlatformJsonWeek',ss,tit,lookMoreRank)
        break
      case ('platform' + 2):
        if(nextTime){
          ss=moment(nextTime,'YYYY-MM').add(1,'month').subtract(1,'days').format('YYYY-MM-DD')
        }else{
          ss=moment().date(1).subtract(1,'days').format('YYYY-MM-DD')
        }
        artTime=(`${moment(ss,'YYYY-MM-DD').date(1).format('YYYY-MM-DD')},${moment(ss,'YYYY-MM-DD').format('YYYY-MM-DD')}`)
        this.setState({selectTime:nextTime||defaultMonth})
        this.props.getArtTime(artTime)
        this.doFetchData('getPlatformJsonMonth',ss,tit,lookMoreRank)
        break
    }
  }


  getBrandAndDataNum=()=>{
    getBrandAndDataLength()
      .then(res => {
        if (!res) return 
        this.setState({
          brandCount: res.brandLength,
          dataLength: res.dataLength,
        })
      })
  }
  
  doFetchData = (fuc,ss,tit,lookMoreRank) => {
    let url,period,cardUrl
    let getList, getCard

    this.setState({
      loading: true,
      error: false,
      cardItems: []
    })


    switch (fuc) {
      //总榜
      case 'getChampionJsonDay':
        getList = getChampionJsonDay({
          statisDate: ss || this.state.selectTime,
          num: lookMoreRank ? '1100' : '100'
        })
        getCard = getChampionJsonDayCard({
          statisDate: ss || this.state.selectTime,
          num: lookMoreRank ? '1100' : '100'
        })
        url = `/digitalAssets/getChampionJsonDay?statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'1100':'100'}`;
        cardUrl =`/digitalAssets/getChampionJsonDayCard?statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'1100':'100'}`
        period='ranking0'
        break;

      case 'getChampionJsonWeek':
        getList = getChampionJsonWeek({
          statisDate: ss||this.state.selectTime,
          num: 100
        })
        getCard = getChampionJsonWeekCard({
          statisDate: ss||this.state.selectTime,
          num: 100
        })
        url = `/digitalAssets/getChampionJsonWeek?statisDate=${ss||this.state.selectTime}&num=${'100'}`;
        cardUrl =`/digitalAssets/getChampionJsonWeekCard?statisDate=${ss||this.state.selectTime}&num=${'100'}`
        period='ranking1'
        break
        
      case 'getChampionJsonMonth':
        getList = getChampionJsonMonth({
          statisDate: ss||this.state.selectTime,
          num: 100
        })
        getCard = getChampionJsonMonthCard({
          statisDate: ss||this.state.selectTime,
          num: 100
        })

        url = `/digitalAssets/getChampionJsonMonth?statisDate=${ss||this.state.selectTime}&num=${'100'}`;
        cardUrl =`/digitalAssets/getChampionJsonMonthCard?statisDate=${ss||this.state.selectTime}&num=${'100'}`
        period='ranking2'
        break

      //行业榜
      case 'getIndustryJsonDay':
        getList = getIndustryJsonDay({
          areaIndustry: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getIndustryJsonDayCard({
          areaIndustry: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getIndustryJsonDay?areaIndustry=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getIndustryJsonDayCard?areaIndustry=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='industry0'
        break

      case 'getIndustryJsonWeek':

        getList = getIndustryJsonWeek({
          areaIndustry: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getIndustryJsonWeekCard({
          areaIndustry: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getIndustryJsonWeek?areaIndustry=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getIndustryJsonWeekCard?areaIndustry=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='industry1'
        break
        
      case 'getIndustryJsonMonth':
        
        getList = getIndustryJsonMonth({
          areaIndustry: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getIndustryJsonMonthCard({
          areaIndustry: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getIndustryJsonMonth?areaIndustry=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getIndustryJsonMonthCard?areaIndustry=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='industry2'
        break

      //平台榜
      case 'getPlatformJsonDay':

        getList = getPlatformJsonDay({
          Platform: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'1100':'20'
        })
        getCard = getPlatformJsonDayCard({
          Platform: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getPlatformJsonDay?Platform=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'1100':'20'}`;
        cardUrl = `/digitalAssets/getPlatformJsonDayCard?Platform=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='platform0'
        break
        
      case 'getPlatformJsonWeek':

        getList = getPlatformJsonWeek({
          Platform: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getPlatformJsonWeekCard({
          Platform: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getPlatformJsonWeek?Platform=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getPlatformJsonWeekCard?Platform=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='platform1'
        break

      case 'getPlatformJsonMonth':

        getList = getPlatformJsonMonth({
          Platform: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getPlatformJsonMonthCard({
          Platform: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getPlatformJsonMonth?Platform=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getPlatformJsonMonthCard?Platform=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='platform2'
        break

      //地理榜
      case 'getGeoJsonDay':

        getList = getGeoJsonDay({
          region: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getGeoJsonDayCard({
          region: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        url = `/digitalAssets/getGeoJsonDay?region=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getGeoJsonDayCard?region=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='geo0'
        break
        
      case 'getGeoJsonWeek':

        getList = getGeoJsonWeek({
          region: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getGeoJsonWeekCard({
          region: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getGeoJsonWeek?region=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getGeoJsonWeekCard?region=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='geo1'
        break

      case 'getGeoJsonMonth':
        getList = getGeoJsonMonth({
          region: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })
        getCard = getGeoJsonMonthCard({
          region: tit,
          statisDate: ss||this.state.selectTime,
          num: lookMoreRank?'500':'20'
        })

        url = `/digitalAssets/getGeoJsonMonth?region=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        cardUrl = `/digitalAssets/getGeoJsonMonthCard?region=${encodeURIComponent(tit)}&statisDate=${ss||this.state.selectTime}&num=${lookMoreRank?'500':'20'}`;
        period='geo2'
        break
      
      default:
        break;
    } 

    
    //请求榜单
    // fetch(url)
    //   .then(response => response.json())
    getList
      .then(data => {
        const valid = this.props.rank + this.state.periodIndex

        if(period==valid){
          this.setState({
              loading:false,
              rankItems:data.rankItems,
              // cardItems:data.card,
          })
      
        }
      })
      .catch(e => {
          this.setState({
              rankItems:[],                
              loading:false,
              error:true
          })
      })


      //请求卡片
      // fetch(cardUrl)
      //   .then(response => response.json())
      getCard
        .then(data => {
        //   console.log(data,'地理日数据拉取')
        const valid=this.props.rank+this.state.periodIndex

        if(period==valid){

            this.setState({
                // loading:false,
                // rankItems:data.rankItems,
                cardItems:data.card,
            })
        }
        
        })
        .catch(e => {
            console.log("Oops, error", e)
            this.setState({
                // loading:false,
                // error:true
            })
        })

  }
  
  componentWillMount() {
      if(moment().format('a')=='pm'){
          this.setState({selectTime:moment().subtract(1,'days').format('YYYY-MM-DD')})

      }else{
          this.setState({selectTime:moment().subtract(2,'days').format('YYYY-MM-DD')})
      }
  }
  componentDidMount() {
    this.getBrandAndDataNum()
  }


  componentWillReceiveProps = (nextProps) => {
    if (nextProps.tit==this.props.tit&&!this.isInit){
      this.isInit=true
      this.changeSelecPeriod(this.state,nextProps)
      
    } else if(nextProps.tit!=this.props.tit){
      this.changeSelecPeriod(this.state,nextProps)
      this.isInit=true
    }
  }


  //渲染表格
  renderTbody = (i) => {
    const { rank } = this.props
    const { rankItems } = this.state
    switch (rank + i) {
      // console.log('行业榜-日')
      case ('industry0'):
        return (
          <tbody>
            {this.state.rankItems.map((item, index) =>
              <tr key={index}>
                <th>{index + 1}</th>
                <td>
                  <img src={brandIcon(item.id)}/>
                  <Link to={aLink({
                    brandName: item.name,
                    industry: this.props.tit 
                  })}>{item.name}</Link>
                </td>
                <td>{parseFloat(item.db).toLocaleString()}</td>
                <td className={s.isUp}>{item.daily}
                  <span className={s[item.dailyStyle]}></span>
                </td>
                <td>{item.spread}</td>
                <td>{item.participate}</td>
                <td>{item.favorability}</td>
                <td>{item.mind}</td>
                <td className={s.isUp}>{item.mindNum}
                  <span className={s[item.mindStyle]}></span>
                </td>
              </tr>
            )}
          </tbody>
        )
        break

      // console.log('行业周')
      case ('industry1'):
        return (
          <tbody>
            {this.state.rankItems.map((item, index) =>
              <tr key={index}>
                <th>{index + 1}</th>
                <td>
                  <img src={brandIcon(item.id)}/>
                  <Link to={aLink({
                    brandName: item.name,
                    industry: this.props.tit
                  })}>{item.name}</Link>
                </td>
                <td>{parseFloat(item.db).toLocaleString()}</td>
                <td className={s.isUp}>{item.daily}
                  <span className={s[item.dailyStyle]}></span>
                </td>
                <td>{ parseFloat(item.peak).toLocaleString()}</td>
                <td>{ parseFloat(item.trough).toLocaleString()}</td>
                <td>{item.mind}</td>
                <td className={s.isUp}>{item.mindNum}
                  <span className={s[item.mindStyle]}></span>
                </td>
              </tr>
            )}
          </tbody>
        )
        break
      
      // console.log('行业月')
      case ('industry' + 2):
        return (
          <tbody>
            {this.state.rankItems.map((item, index) =>
              <tr key={index}>
                <th>{index + 1}</th>
                <td>
                  <img src={brandIcon(item.id)}/>
                  <Link to={aLink({
                    brandName: item.name,
                    industry: this.props.tit
                  })}>{item.name}</Link>
                </td>
                <td>{parseFloat(item.db).toLocaleString()}</td>
                <td className={s.isUp}>{item.daily}
                  <span className={s[item.dailyStyle]}></span>
                </td>
                <td>{ parseFloat(item.peak).toLocaleString()}</td>
                <td>{ parseFloat(item.trough).toLocaleString()}</td>
                <td>{item.mind}</td>
                <td className={s.isUp}>{item.mindNum}
                  <span className={s[item.mindStyle]}></span>
                </td>
              </tr>
            )}
          </tbody>
        )
        break
        
      // console.log('总榜日')
      case ('ranking' + 0):
        return (
          <tbody>
            {rankItems.map((item, index) =>
              <tr key={index}>
                <th>{index + 1}</th>
                <td>
                <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
                </td>
                <td>{item.industry}</td>
                <td>{parseFloat(item.db).toLocaleString()}</td>
                <td className={s.isUp}>{item.daily}
                    <span className={s[item.dailyStyle]}></span>
                </td>
                <td>{item.spread}</td>
                <td>{item.participate}</td>
                <td>{item.favorability}</td>
                <td>{item.mind}</td>
              </tr>
            )}
          </tbody>

        )
        break

      // console.log('总榜周')
      case ('ranking' + 1):
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{ parseFloat(item.peak).toLocaleString()}</td>
                                <td>{ parseFloat(item.trough).toLocaleString()}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                                <td className={s.isUp}>{item.king}
                                    <span className={s[item.kingStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('ranking' + 2):
                // console.log('总榜月')
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{ parseFloat(item.peak).toLocaleString()}</td>
                                <td>{ parseFloat(item.trough).toLocaleString()}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                                <td className={s.isUp}>{item.king}
                                    <span className={s[item.kingStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('geo' + 0):
                // console.log('地理日')
                return (
                    <tbody>
                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}&geo=${this.props.tit}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{item.spread}</td>
                                <td>{item.participate}</td>
                                <td>{item.favorability}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('geo' + 1):
                // console.log('地理周')
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}&geo=${this.props.tit}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{ parseFloat(item.peak).toLocaleString()}</td>
                                <td>{ parseFloat(item.trough).toLocaleString()}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('geo' + 2):
                // console.log('地理月')
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}&geo=${this.props.tit}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{ parseFloat(item.peak).toLocaleString()}</td>
                                <td>{ parseFloat(item.trough).toLocaleString()}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('platform' + 0):
                // console.log('平台日')
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                        <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{item.spread}</td>
                                <td>{item.participate}</td>
                                <td>{item.favorability}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('platform' + 1):
                // console.log('平台周')
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{parseFloat(item.peak).toLocaleString()}</td>
                                <td>{parseFloat(item.trough).toLocaleString()}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
            case ('platform' + 2):
                // console.log('平台月')
                return (
                    <tbody>

                        {rankItems.map((item, index) =>
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                                    <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
                                </td>
                                <td>{item.industry}</td>
                                <td>{parseFloat(item.db).toLocaleString()}</td>
                                <td className={s.isUp}>{item.daily}
                                    <span className={s[item.dailyStyle]}></span>
                                </td>
                                <td>{parseFloat(item.peak).toLocaleString()}</td>
                                <td>{parseFloat(item.trough).toLocaleString()}</td>
                                <td>{item.mind}</td>
                                <td className={s.isUp}>{item.mindNum}
                                    <span className={s[item.mindStyle]}></span>
                                </td>
                            </tr>
                        )}
                    </tbody>

                )
                break
        }

    }
    openCalendar = () => {
        this.setState({
            isShow: !this.state.isShow,
        })
    }
    closeCalendar = (ss) => {
        this.setState({
            isShow: false,
            selectTime: ss
        })
        this.changeSelecPeriod({nextTime:ss},this.props)
    }

    renderTabular=()=>{
        const {rank,tit}=this.props
        // console.log(rank,tit)
        if(rank=='geo'){
            return <span>指该品牌在归属地区范围内所有调研品牌中，以DB总值计算的受众心智占有份额，反映了该品牌对该地区营商声誉总体评价的影响度</span>
        }else if(rank=='industry'){
            return <span>指该品牌在同行业所有调研品牌中，以DB总值计算的受众心智占有份额。</span>
        }else if(rank=='ranking'){
            return <span>指该品牌在同行业所有调研品牌中，以DB总值计算的受众心智占有份额；当该品牌涉及多个行业时，只显示它在不同行业内心智占有率最高的数值，其它数值详见该品牌详情页。</span>
        }else if(rank=='platform'){
            return <span>指该品牌在{tit}平台上，在同行业所有调研品牌中，以DB总值计算的受众心智占有份额。</span>
        }
    }


  
    renderHeader = () => {
      const { rank } = this.props
      const { periodIndex, cardItems } = this.state
      return (
        <ul className={s.rankNo1} >
          <li className={s.no1Item}>
            <i className={s.rankImg}><img src={icon_db} /></i>
            <span className={s.no1Tit}>{Txt[rank].card[periodIndex][0]}<b>No.1</b></span>
            <span className={s.no1Name}>
              {cardItems.length!=0&&<Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(cardItems[0].brandName))}`}>{cardItems[0].brandName||''}</Link>}
            </span>
            <span className={s.no1Value}>{cardItems.length!=0&&parseFloat(cardItems[0].db).toLocaleString()}</span>
          </li>
              
          <li className={s.no1Item}>
            <i className={s.rankImg}><img src={icon_count} /></i>
            <span className={s.no1Tit}>{Txt[rank].card[periodIndex][1]}<b>No.1</b></span>
            <span className={s.no1Name}>
              {cardItems.length!=0&&<Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(cardItems[1].brandName))}`}>{cardItems[1].brandName||'无'}</Link>}
            </span>
            <span className={s.no1Value}>{cardItems.length!=0&&cardItems[1].chg_rate}
              <i className={s.up}></i>
            </span>
          </li>
              
          <li className={s.no1Item}>
            <i className={s.rankImg}><img src={icon_increase} /></i>
            <span className={s.no1Tit}>{Txt[rank].card[periodIndex][2]}<b>No.1</b></span>
            <span className={s.no1Name}>
              {cardItems.length!=0&&<Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(cardItems[2] ? cardItems[2].brandName : ''))}`}>{cardItems[2] ? cardItems[2].brandName||'无' : '无'}</Link>}
            </span>
            <span className={s.no1Value}>{cardItems.length!=0 && cardItems[2] && cardItems[2].chg_rate}
              <i className={s.down}></i>
            </span>
          </li>
          
          <li className={s.no1Item}>
            <i className={s.rankImg}><img src={icon_mind} /></i>
            <span className={s.mindSpan}>{Txt[rank].card[periodIndex][3]}</span>
            <span className={s.no1Tit}>{Txt[rank].card[periodIndex][4]}<b>No.1</b></span>
            <span className={s.no1Name}>
              {cardItems.length!=0&&<Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(cardItems[3] ? cardItems[3].brandName : ''))}`}>{cardItems[3] ? cardItems[3].brandName||'' : ''}</Link>}
            </span>
            <span className={s.no1Value}>{cardItems.length!=0&&cardItems[3]&&cardItems[3].mind}</span>
          </li>
        </ul>
      )
    }

    renderTabButton = () => {
      const { tit } = this.props
      const { periodIndex } = this.state

      return (
        <ul className={s.dbBtn}>
          {btn.map((item, index) =>
            <li key={index}>
              <a href="javascript:;" className={periodIndex == index ? cx(s.dayBtn, s.ac) : s.dayBtn} 
                onClick={() => {
                  this.changeSelecPeriod({
                    index: index
                  }, {tit})
                }}>{item}</a>
            </li>
          )}
        </ul>
      )
    }


  render() {
    const { lookMoreRank, isShowLabel ,brandCount,dataLength, isShow, periodIndex, getTime, rankItems, cardItems, selectTime,loading,error,isCalendarCon } = this.state
    const { rank, tit } = this.props
    const getTbody = this.renderTbody(periodIndex)
    
    let subtractDays=moment().format('a')=='pm'?1:2
    
    return (
      <div className={s.root}>
        <div className={s.rank_head}>
          <h2 className={s.rank_tit} >
            {this.props.treeLevel>1?`细分领域—${tit}`:`${Txt[rank]['title'] + tit}`}
          </h2>
          </div>
            {this.renderHeader()}
            
            <div className={s.dbTableBox} >
              <div className={s.rankHead}>
                {/* 日榜 周榜 月榜 */}
                {this.renderTabButton()}

                <div className={s.fr}>
                  <div className={s.timeItem} onBlur={()=>!isCalendarCon?this.setState({isShow:false}):null}  tabIndex='0'>
                    <span className={s.timeInfoTxt}></span>
                    <div className={s.month} onClick={this.openCalendar}>
                      <i className={s.monthIcon}></i>
                      <span className={s.monthTxt} >{selectTime}</span>
                    </div>

                    <Calendar 
                      getSelectTime={this.getSelectTime}
                      isShow={this.state.isShow}
                      close={this.closeCalendar}
                      cycle={btn[periodIndex]} 
                      en={this.enCalendarCon}
                      ov={this.ovCalendarCon}
                    />
                  </div>
                  
                  <span className={s.deadline}>
                    <span className={s.timeOut}>数据截至时间：{moment().subtract(subtractDays,'days').format('YYYY-MM-DD')}</span>
                    24 时
                    <span className={s.timeOut}>已追踪品牌数：{brandCount} 个</span>
                    <span className={ s.timeOut}>本日新增数据量：{dataLength} 条</span>
                  </span>
                </div>
              </div>

              <div  className={s.dbTable}>
                <table cellSpacing="0" cellPadding="0">
                  <thead key='1'>
                    <tr>
                      {Txt[rank].items[periodIndex].map((item, index) =>
                        <th key={index} dangerouslySetInnerHTML={{__html:item}}/>
                      )}
                    </tr>
                  </thead>
                </table>
                
                <div className={s.hideScroll}>
                  <div className={s.overTable}>
                    <table cellSpacing="0" cellPadding="0" className={s.hideTable}>
                      {loading?null:getTbody}
                    </table>
                    {loading?this.loadingShow():null}
                  </div>

                  <span className={s.tabular}><span className={s.red}>*</span> {this.renderTabular()}</span>
                </div>

                <div className={s.lookMore} >
                <span className={s.lookMoreTxt} style={{color:lookMoreRank?'#2196F3':'#000'}}>完整榜单</span>
                  <span className={s.switchBox}>
                  <label className={s.switch}>
                    <input
                      type="checkbox"
                      onChange={(e)=>{
                        this.changeSelecPeriod({lookMoreRank:!lookMoreRank},{})
                      }}
                      checked={lookMoreRank?'checked':null} />
                    <span className={cx(s.slider,s.round)}></span>
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      )
    }
}

export default withStyles(s)(Ranktable);


// WEBPACK FOOTER //
// src/components/Ranktable/Ranktable.js